module.exports = __webpack_public_path__ + "6adf96a85713e8f86ed2dbdf1e1b9444.svg";